export default "__VITE_ASSET__ff8cddd9__"